import { GameManager } from "../GameManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { AudioManager } from "../AudioManager";
import { Howl } from "howler";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;
    private scaledItemsContainer: Phaser.GameObjects.Container;

    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {

        this.composeScene();

        this.loadAssets();
    }

    public create(): void {

        // A LOS DE CRAZY GAMES LES DA PROBLEMAS
        if (GameVars.isMobile) {
            const aspectRatio = window.innerWidth / window.innerHeight;
            GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / aspectRatio;
        }

        let audioSpriteJSON = this.cache.json.get("audiosprite");
        audioSpriteJSON = JSON.parse(JSON.stringify(audioSpriteJSON).replace("urls", "src"));
        audioSpriteJSON = JSON.parse(JSON.stringify(audioSpriteJSON).replace("../", ""));
        audioSpriteJSON = JSON.parse(JSON.stringify(audioSpriteJSON).replace("../", ""));

        AudioManager.howl = new Howl(audioSpriteJSON);

        const self = this;

        AudioManager.howl.on("load", () => {

            self.tweens.add({
                targets: self.scaledItemsContainer,
                scaleX: 0,
                alpha: .25,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 600,
                delay: 500,
                onComplete: () => {
                    GameManager.onGameAssetsLoaded();
                },
                onCompleteScope: self
            });
        });
    }
    
    private composeScene(): void {

        this.add.text(-100, -100, "abcdefg", { fontFamily: "OpenSans-CondLight", fontSize: "26px", color: "#FFFF00" });
        this.add.text(-100, -100, "abcdefg", { fontFamily: "OpenSans-CondLight", fontSize: "26px", color: "#FFFF00" });
        this.add.text(-100, -100, "abcdefg", { fontFamily: "Amatic-Regular", fontSize: "26px", color: "#FFFF00" });

        const background = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "background");
        background.scaleX = GameVars.scaleX;
        this.add.existing(background);

        if (GameVars.isMobile) {

            const aspectRatio = window.innerWidth / window.innerHeight;

            if (aspectRatio > 2.2) {
                background.scaleX = 1.25 * GameVars.scaleX;
                background.scaleY = 1.25;
            }
        }

        this.scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        this.scaledItemsContainer.scaleX = GameVars.scaleX;

        const brandingCapsule = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 - 30, "branding_capsule");
        brandingCapsule.scaleX = GameVars.scaleX;

        const barWidth = 750;
        const barWHeight = 8;
        const borderWidth = 3;

        const preloadBarCapsuleBorder = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsuleBorder.fillStyle(0x9d7868);
        preloadBarCapsuleBorder.fillRect(0, 0, barWidth + borderWidth * 2, barWHeight + borderWidth * 2);
        preloadBarCapsuleBorder.x = - barWidth / 2 - borderWidth;
        preloadBarCapsuleBorder.y = -borderWidth + 340;
        this.scaledItemsContainer.add(preloadBarCapsuleBorder); 

        const preloadBarCapsule = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsule.fillStyle(0xefd5a9);
        preloadBarCapsule.fillRect(0, 0, barWidth, barWHeight);
        preloadBarCapsule.x = - barWidth / 2;
        preloadBarCapsule.y = 340;
        this.scaledItemsContainer.add(preloadBarCapsule); 

        this.progressBar = new Phaser.GameObjects.Graphics(this);
        this.progressBar.fillStyle(0xa78866);
        this.progressBar.fillRect(0, 0, barWidth, barWHeight);
        this.progressBar.x = - barWidth / 2;
        this.progressBar.y = 340;
        this.progressBar.scaleX = 0;
        this.scaledItemsContainer.add(this.progressBar); 
    }

    private loadAssets(): void {
        
        // this.load.image("score_system", "assets/score_system.png");
        this.load.image("how_to_play", "assets/how_to_play.jpg");
        this.load.image("background_level_selection_scene", "assets/bg.jpg");

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        this.load.atlas("texture_atlas_2", "assets/texture_atlas_2.png", "assets/texture_atlas_2.json");
        this.load.atlas("texture_atlas_3", "assets/texture_atlas_3.png", "assets/texture_atlas_3.json");
        this.load.atlas("texture_atlas_4", "assets/texture_atlas_4.png", "assets/texture_atlas_4.json");

        this.load.json("boards", "assets/game-boards.json");

        // EL AUDIO SPRITE
        this.load.json("audiosprite", "assets/audio/audiosprite.json");

        // LOS TEXTOS TRADUCIDOS
        this.load.json("text", "assets/text.json");

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {

        if (this.progressBar.scaleX < percentageLoaded) {
            this.progressBar.scaleX = percentageLoaded;
        }
    }
}
